/*
 * Saves a file under its own name without opening it (owner, 2026-10-20): a link to the file with `download`, which
 * the browser saves itself (a document's address with ?download is also sent as an attachment). Not fetched first
 * and handed over as a blob: Firefox on Android fetched it, then saved nothing (2026-10-27). The link goes in the open
 * dialog, if any: outside it the page is inert. No rel=noopener: with it Firefox on Android opened an empty tab.
 */
window.download = function download(url, filename = 'file.pdf') {
    const link = Object.assign(document.createElement('a'), {href: url, download: filename});
    ([...document.querySelectorAll('dialog[open]')].pop() ?? document.body).append(link);
    link.click();
    link.remove();
};
